<template>
  <div class="card-body activity-exam-marks">
    <div class="card height-auto v-application--is-ltr text-left">
      <div class="card-body">
        <v-row class="headerTable-div">
          <v-col md="4" sm="12">
            <p class="title main-color" style="text-align: left">
              {{ page_title }}
            </p>
            <p
              class="font-weight-bold small"
              style="text-align: left"
              v-if="breadcrumb"
            >
              {{ breadcrumb }}
            </p>
          </v-col>
          <v-col md="6" sm="12"></v-col>
          <v-col md="2" sm="12">
            <v-btn
              icon
              to="/systemlogging/student_exam_submited"
              v-if="canShowLog"
              target="_blank"
            >
              <v-icon class="main-color" large :title="$t('System Log')"
                >mdi-archive-clock</v-icon
              >
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mb-7">
          <v-col md="5" cols="12">
            <!-- Class -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Class</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Class')"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  v-model="selectedClass"
                  @change="getClassStudents"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider
          style="background-color: #ddd !important; margin-bottom: 20px"
          class="mt-4 mb-4 main-color"
        ></v-divider>
        <v-row>
          <div class="card-body">
            <div class="row actions-container mt-5 mb-7">
              <div class="actions">
                <v-icon
                  v-if="!edit_mode && !exam_online"
                  :title="$t('Edit')"
                  style="cursor: pointer"
                  class="main-color edit-icon"
                  @click="edit_mode = true"
                  >edit</v-icon
                >
                <span
                  v-if="edit_mode"
                  class="main-color pr-3"
                  style="cursor: pointer"
                  @click="saveMarks"
                  >{{ $t("Update") }}</span
                >
                <span
                  v-if="edit_mode"
                  style="color: #646464; cursor: pointer"
                  @click="
                    edit_mode = false;
                    getClassStudents();
                  "
                  >{{ $t("Cancel") }}</span
                >
              </div>
            </div>
            <!-- v-model="selected" -->
            <v-alert color="#eaeefc" v-if="errorEmptyItems == true">
              {{ $t("There is no marks") }}
            </v-alert>

            <v-form v-model="valid" ref="form" class="py-4">
              <!-- :options.sync="options" -->
              <v-data-table
                :loading="loading"
                loading-text="Loading... Please wait"
                :headers="headers"
                :items="items"
                item-key="id"
                :show-select="false"
                class="elevation-1 level1 templates font-weight-light"
                text="left"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:header.mark="{ header }">
                  Mark ( {{ current_exam_mark }} )
                </template>

                <template
                  v-slot:header.confirmed="{ header }"
                  v-if="hasConfirmStudentExamMarkPermission"
                >
                  <div class="text-center pt-2">
                    <v-btn
                      class="modal-btn-save saveBtn text-capitalize"
                      @click="confirm_all_confirmation_dialog = true"
                      large
                      v-if="!edit_mode"
                    >
                      {{ $t("Confirm All") }}
                    </v-btn>
                  </div>
                </template>

                <template v-slot:item.exam_type="{ item }">
                  <router-link
                    :to="
                      '/examCorrection/' +
                      item.academic_year_id +
                      '/' +
                      item.class_id +
                      '/' +
                      item.exam_id +
                      '/' +
                      item.student_id
                    "
                    v-if="
                      !item.exam_running &&
                      !edit_mode &&
                      item.online_exam &&
                      item.student_exam_submited
                    "
                    >Online</router-link
                  >
                  <p
                    v-if="
                      (item.online_exam && item.exam_running) ||
                      (item.online_exam && edit_mode) ||
                      (item.online_exam && !item.student_exam_submited)
                    "
                  >
                    Online
                  </p>
                  <p v-if="item.exam_id && !item.online_exam">Offline</p>
                </template>
                <template v-slot:item.mark="{ item }">
                  <v-row class="justify-content-center">
                    <v-col cols="6" class="pr-3 pt-2 pb-1 text-center">
                      <v-text-field
                        v-if="
                          item.exam_id != '' &&
                          !item.online_exam &&
                          !item.confirmed &&
                          edit_mode
                        "
                        type="number"
                        style="width: 100%"
                        solo
                        v-model="item.mark"
                        :rules="[
                          validationRules.positiveFloatNumberWithTwoDecimalOrZero,
                          validationRules.lessThanOrEqualNumber(
                            item.mark,
                            item.exam_mark
                          ),
                          validationRules.moreThanOrEqualValue(item.mark, 0),
                        ]"
                      ></v-text-field>
                      <p v-if="!edit_mode || (edit_mode && item.confirmed)">
                        {{ item.mark }}
                      </p>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.confirmed="{ item }">
                  <v-row>
                    <v-col cols="12" class="pr-3 pt-2 pb-1">
                      <p
                        v-if="
                          hasConfirmStudentExamMarkPermission &&
                          !edit_mode &&
                          item.exam_id != '' &&
                          item.mark != '' &&
                          !item.confirmed
                        "
                        class="main-color pr-3"
                        style="cursor: pointer"
                        @click="
                          confirmStudentExamMark(item.exam_id, item.student_id)
                        "
                      >
                        {{ $t("Confirm") }}
                      </p>
                      <p
                        v-if="
                          hasUnConfirmStudentExamMarkPermission &&
                          !edit_mode &&
                          item.exam_id != '' &&
                          item.mark != '' &&
                          item.confirmed
                        "
                        class="main-color pr-3"
                        @click="
                          showUnconfirmDialog(
                            item.exam_id,
                            item.student_id,
                            item.student_name,
                            item.exam_name
                          )
                        "
                        style="cursor: pointer; color: #6c757d !important"
                      >
                        {{ $t("Unconfirm") }}
                      </p>
                      <p
                        v-if="
                          (!hasUnConfirmStudentExamMarkPermission ||
                            edit_mode) &&
                          item.exam_id != '' &&
                          item.mark != '' &&
                          item.confirmed
                        "
                        class="main-color pr-3"
                        style="cursor: pointer; color: #6c757d !important"
                      >
                        {{ $t("Confirmed") }}
                      </p>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-form>
          </div>
          <!-- students class -->
        </v-row>
      </div>
    </div>
    <v-dialog
      v-model="confirm_all_confirmation_dialog"
      persistent
      max-width="320"
      class="dialog_confirm"
    >
      <v-card>
        <v-card-title class="headline">{{
          $t("Confirmation Message")
        }}</v-card-title>

        <v-card-text>{{
          $t(
            "Are you sure you want to confirm marks of all corrected exams in this class?"
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="modal-btn-cancel noBtn"
            @click="confirm_all_confirmation_dialog = false"
            id="noBtn"
            ref="always_focus"
            >{{ $t("No") }}</v-btn
          >
          <v-btn
            id="yesBtn"
            @click="
              confirm_all_confirmation_dialog = false;
              confirmAllStudentsExamsMarks();
            "
            class="modal-btn-save yesBtn"
            >{{ $t("Yes") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="single_confirm_confirmation_dialog.show"
      persistent
      max-width="320"
      class="dialog_confirm"
    >
      <v-card>
        <v-card-title class="headline">{{
          $t("Confirmation Message")
        }}</v-card-title>

        <v-card-text>{{
          $t(`Are you sure you want to Unconfirm exam ${single_confirm_confirmation_dialog.examName}
             mark for ${single_confirm_confirmation_dialog.studentName}?`)
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="modal-btn-cancel noBtn"
            @click="single_confirm_confirmation_dialog.show = false"
            id="noBtn"
            ref="always_focus"
            >{{ $t("No") }}</v-btn
          >
          <v-btn
            id="yesBtn"
            @click="
              unConfirmStudentExamMark(
                single_confirm_confirmation_dialog.examId,
                single_confirm_confirmation_dialog.studentId
              )
            "
            class="modal-btn-save yesBtn"
            >{{ $t("Yes") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="snackTime"
      :color="snackColor"
      :right="true"
      :top="true"
    >
      <!-- {{ snackText }} -->

      <span class="white--text">{{ snackText }}</span>

      <v-btn text @click="snack = false">{{ $t("Close") }}</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
// import addEditExamComponent from "../../components/modals/addEditExamComponent";
import { validationMixin } from "../../mixins/validationMixin";
import ACL from "../../acl";

export default {
  name: "ActivityExamMarks",
  // components: { addEditExamComponent },
  mixins: [validationMixin],
  data() {
    return {
      academic_grade_year_id: "",
      exam_online: false,
      exam_id: "",
      breadcrumb: "",
      exam_name: "",
      canShowLog: ACL.checkPermission("activitylog"),
      confirm_all_confirmation_dialog: false,
      current_exam_mark: "",
      hasConfirmStudentExamMarkPermission: ACL.checkPermission(
        "confirm-student-marks"
      ),
      hasUnConfirmStudentExamMarkPermission: ACL.checkPermission(
        "unconfirm-student-marks"
      ),
      single_confirm_confirmation_dialog: {
        show: false,
        examId: "",
        studentId: "",
        studentName: "",
        examName: "",
      },
      valid: false,
      loading: false,
      snackTime: 3000,
      snackColor: "success",
      selectAllStudent: false,
      snackText: "",
      snack: false,
      page_title: "General Exam Correction",

      selectedClass: "",
      // selectedExam: "",
      edit_mode: false,
      // edit_mode_grade: false,
      // showErrorMessageStudentSelect: false,
      // showSelectExamOnGrade: false,
      quarters: [],
      subjects: [],
      grades: [],
      qualifiers: [],
      activities: [],
      classes: [],
      items: [],
      headers: [
        {
          text: this.$i18n.t("Student"),
          value: "student_name",
          sortable: true,
          align: "start",
        },
        {
          text: this.$i18n.t("Type"),
          value: "exam_type",
          sortable: true,
          align: "center",
        },
        // {
        //   text: this.$i18n.t("Type"),
        //   value: "type",
        //   sortable: true,
        //   align: "center",
        // },
        {
          text: this.$i18n.t("Mark"),
          value: "mark",
          sortable: true,
          align: "center",
          width: "23%",
        },
        {
          text: this.$i18n.t(""),
          value: "confirmed",
          sortable: false,
          align: "center",
          width: "20%",
        },

        // { text: this.$i18n.t("Actions"), value: "actions", sortable: false },
      ],
      // exams: [],

      search: "",
      currntQuarterid: "",
      errorEmptyItems: "",
      // selected: [],
    };
  },
  watch: {
    // selectedClass: {
    //   handler() {
    //     this.getClassStudents();
    //   },
    //   deep: true,
    // },
    // selectedClass: {
    //   handler() {
    //     if (this.selectedClass != "" && this.selectedClass != "all_class") {
    //       this.showSelectExamOnGrade = false;
    //       this.getClassStudents();
    //     } else if (this.selectedClass == "all_class") {
    //       this.items = [];
    //       this.showSelectExamOnGrade = true;
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    cancel() {
      this.edit_mode = false;
    },
    // select(item) {
    //   item.selected = !item.selected;
    // },
    // selectAll() {
    //   this.selectAllStudent = !this.selectAllStudent;
    //   this.items.forEach((el) => {
    //     el.selected = this.selectAllStudent;
    //   });
    // },

    saveMarks() {
      if (!this.valid) {
        this.$refs.form.validate();
      } else {
        axios
          .post(
            this.getApiUrl + "/performance/update-students/activity-exams/mark",
            {
              items: this.items,
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            if (response.data.status.error == false) {
              this.getClassStudents();
              this.edit_mode = false;
            }
          });
      }
    },
    getClassStudents() {
      //   if (this.selectedClass != "") {
      this.loading = true;
      axios
        .get(
          this.getApiUrl +
            "/performance/general-correct-exam-students/" +
            this.exam_id +
            "?class_id=" +
            this.selectedClass,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          this.loading = false;
          this.items = [];
          this.items = response.data.data.students;
          this.current_exam_mark = response.data.data.exam_mark;
          this.exam_online = response.data.data.exam_online;
        });
      //   }
    },
    confirmStudentExamMark(examId, studentId) {
      axios
        .get(
          this.getApiUrl +
            "/performance/confirm-student-exam-mark/" +
            examId +
            "/" +
            studentId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then(() => {
          this.getClassStudents();
        });
    },
    showUnconfirmDialog(examId, studentId, studentName, examName) {
      this.single_confirm_confirmation_dialog.show = true;
      this.single_confirm_confirmation_dialog.examId = examId;
      this.single_confirm_confirmation_dialog.studentId = studentId;
      this.single_confirm_confirmation_dialog.studentName = studentName;
      this.single_confirm_confirmation_dialog.examName = examName;
    },
    unConfirmStudentExamMark(examId, studentId) {
      axios
        .get(
          this.getApiUrl +
            "/performance/un-confirm-student-exam-mark/" +
            examId +
            "/" +
            studentId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then(() => {
          this.single_confirm_confirmation_dialog.show = false;
          this.single_confirm_confirmation_dialog.examId = "";
          this.single_confirm_confirmation_dialog.studentId = "";
          this.getClassStudents();
        });
    },
    confirmAllStudentsExamsMarks() {
      if (Object.keys(this.items).length === 0) {
        this.errorEmptyItems = true;
        return;
      }
      axios
        .post(
          this.getApiUrl + "/performance/confirm-all-students-exams-marks/",
          {
            examsMarks: this.items,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then(() => {
          this.getClassStudents();
        });
    },
    getGradeClasses() {
      if (this.academic_grade_year_id != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getGradeClasses/" +
              this.academic_grade_year_id +
              "?all_classes",
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            this.classes = response.data.data;
            // this.selectedClass = this.classes[0];
          });
      }
    },
    getBreadCrumb() {
      // /getBreadcrumb/assign-general-exam'
      if (
        this.quarter_id != "" &&
        this.academic_grade_year_id != "" &&
        this.exam_id != ""
      ) {
        axios
          .get(
            this.getApiUrl +
              "/performance/getBreadcrumb/assign-general-exam?quarter_id=" +
              this.quarter_id +
              "&academic_grade_year_id=" +
              this.academic_grade_year_id +
              "&exam_id=" +
              this.exam_id,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.breadcrumb = response.data.data.breadcrumb;
            this.exam_name = response.data.data.exam_name;
          });
      }
    },
  },
  mounted() {
    this.academic_grade_year_id =
      this.$router.currentRoute.params.academic_grade_year_id;
    this.exam_id = this.$router.currentRoute.params.examId;
    this.quarter_id = this.$router.currentRoute.params.quarterId;
    this.getBreadCrumb();
    this.getGradeClasses();
    this.getClassStudents();
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

// end search input
.title-page {
  margin-top: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.card-container {
  max-width: 80%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
.actions-container {
  position: relative;
}
.actions {
  position: absolute;
  top: -10px;
  right: 22px;
}
.actions i,
.actions span {
  cursor: pointer;
}
.actions span {
  margin-left: 5px;
}

.title-qualifire .divider {
  margin-top: 10px;
  margin-bottom: 10px;
}
.q-box-title {
  font-size: 29px;
  position: relative;
}

.q-box-title h2 {
  font-size: 25px;
  padding: 0;
  margin: 0;
}

.title-page {
  margin-top: 15px;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #eef3ff;
  margin-bottom: 33px;
}
.v-expansion-panel-content {
  background-color: #f7f7f7;
}
.title-panel {
  color: rgb(114, 151, 255);
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
.details {
  margin-top: 6%;
  overflow: hidden;
}
.details span {
  color: #8d8a8a;
  font-size: 17px;
  font-weight: 700;
}
.details span.passing {
  float: right;
}
.v-expansion-panel-content__wrap {
  padding: 0;
}
.space-name {
  margin-top: -15px !important;
}

.betweencolon {
  position: absolute;
  top: 3rem;
  left: 5%;
}

.dur-error {
  margin-top: 0 !important;
}
.maxSize {
  font-size: 10px;
}
.text-left,
.text-left th,
.text-left td {
  text-align: left !important;
}
</style>
